/* PagingDeviceFeed.js */

const PagingFeed = require("../../../../../../lib/PagingFeed");
const _ = require("lodash");
const without = require("lodash/fp/without");

class PagingDeviceFeed extends PagingFeed {
    _getFeed(options) {
        this._mongoIdOperator = _.get(options, "mongoIdOperator");
        this._idQuery = {id: {}};
        this._setIds([]);
        return this._EntityDef.startDevicesFeed(
            this._activeOrgId,
            this._filter,
            this._entityFields,
            this._sort,
            {
                skip: 0,
                limit: this._pageSize * 2,
            }
        );
    }

    _getDistinctValuesOfField(tenantId, field) {
        return this._EntityDef.startDeviceDistinctValuesFeed(tenantId, field);
    }

    _getFeedIdsForSelection(tenantId, selection) {
        return this._EntityDef.loadDeviceIdsForSelection(tenantId, selection);
    }

    getDeviceEntitiesById(ids) {
        return this.getEntitiesById(ids);
    }

    getDeviceEntitiesNameById(ids) {
        return this.getEntitiesNameById(ids);
    }

    getDeviceEntityById(id) {
        return this.getEntityById(id);
    }

    _getIds() {
        return _.get(this._idQuery, `id.${this._mongoIdOperator}`);
    }
    _setIds(ids) {
        return _.set(this._idQuery, `id.${this._mongoIdOperator}`, ids);
    }

    addIds(addIds, nodeIds) {
        if (!_.isEmpty(nodeIds)) {
            this._filter = {nodeId: {$in: nodeIds}};
        }
        this._setIds(_.union(addIds, this._getIds()));
        this.reestablish();
    }

    removeIds(removeIds, nodeIds) {
        if (!_.isEmpty(nodeIds)) {
            this._filter = {nodeId: {$in: nodeIds}};
        }

        this._setIds(without(removeIds, this._getIds()));
        this.reestablish();
    }

    removeAllIds(isConstruct) {
        if (isConstruct) {
            this._filter = {nodeId: {$in: []}};
        }
        this._setIds([]);
        this.reestablish();
    }
}

module.exports = PagingDeviceFeed;
